import request from '#/utils/request';

import { WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE } from './constants';
import { parseFormCacheEnvelope } from './parseEnvelope';

/**
 * GET /system/form-cache/{scope}
 * 無草稿或已過期 → `data: null`；CONSUMED tombstone 仍回 metadata＋空 payload。
 */
export async function fetchFormCache(
  scope = WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
) {
  const { data: raw } = await request.get(`/system/form-cache/${scope}`);
  return parseFormCacheEnvelope(raw);
}
